'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getEndpoint = require('../get-endpoint');

var _getEndpoint2 = _interopRequireDefault(_getEndpoint);

var _config = require('../config');

var _model = require('./model');

var _model2 = _interopRequireDefault(_model);

var _dataProvider = require('../data-provider');

var _dataProvider2 = _interopRequireDefault(_dataProvider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Gets the footer navigation link data
 * @param {GetFooterLinksDataParamsType} params The function parameters
 * @param {TunnelType} params.tunnel The request tunnel
 * @param {String} [params.platform] The platform to get the data for. Accepts: 'desktop' or 'mobile',
 * defaults to mobile
 * @param {String} [params.lang] The language to get the data for. Defaults to 'en-gb'
 * @returns {Promise<FooterLinksList>} A list of Footer Links
 */
exports.default = function () {
    var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(params) {
        var _params$platform, platform, _params$lang, lang, tunnel, _params$siteType, siteType, siteTypeUrl, endpoint, proxyAgent, data, _data$error, status, title, _data$error$detail, detail, source;

        return _regenerator2.default.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        _params$platform = params.platform, platform = _params$platform === undefined ? 'mobile' : _params$platform, _params$lang = params.lang, lang = _params$lang === undefined ? 'en-gb' : _params$lang, tunnel = params.tunnel, _params$siteType = params.siteType, siteType = _params$siteType === undefined ? 'default' : _params$siteType;
                        siteTypeUrl = siteType === 'default' ? '' : '-' + siteType;
                        endpoint = (0, _getEndpoint2.default)('squiz', '/sportsbook' + siteTypeUrl + '/' + lang + '/site-base/footer-links.json');
                        proxyAgent = (0, _config.getProxy)('squiz');
                        _context.next = 6;
                        return (0, _dataProvider2.default)(endpoint, tunnel, {
                            agent: proxyAgent
                        });

                    case 6:
                        data = _context.sent;

                        if (!data.error) {
                            _context.next = 11;
                            break;
                        }

                        tunnel.log.warn('Failed to fetch Footer Links: ', data.error);

                        _data$error = data.error, status = _data$error.status, title = _data$error.title, _data$error$detail = _data$error.detail, detail = _data$error$detail === undefined ? '' : _data$error$detail, source = _data$error.source;
                        throw new Error('[' + status + '] ' + title + ', ' + detail + '. Source: ' + source);

                    case 11:
                        return _context.abrupt('return', (0, _model2.default)(data, platform));

                    case 12:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, this);
    }));

    function getFooterLinksData(_x) {
        return _ref.apply(this, arguments);
    }

    return getFooterLinksData;
}();
//# sourceMappingURL=footerLinks.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/data-provider/dist/main/footer-links/footerLinks.js
// module id = 445
// module chunks = 0